import { styled } from '../../Utilities';
import { LabelBase } from './Label.base';
import { getStyles } from './Label.styles';
export var Label = styled(LabelBase, getStyles, undefined, {
    scope: 'Label'
});
//# sourceMappingURL=Label.js.map